import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";


const ContactView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClientData] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);


  const isdelete = async () => {
    let result = await trasportApi.deleteClient(client.id);
    if (result.success){
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record deleted successfully' });
        navigate(`/clients`);
    } 
  };

  const editclient = () => {
    navigate(`/clients/${client.id}/e`, { state: client });
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>
             {`${client.client_name}`} 
          </title>
        </Helmet>
      </>
      <div>
        {client && (
          <Container>
            {modalShow && (
              <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              isdelete={isdelete}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="client"
            />
            )}

        
            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight/>
              <Link to="/clients" style={{ "text-decoration": "none" }}>
              Client
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    {/* <div>client Id: {client.contactno}</div> */}
                    <h5>
                      {client.client_name}{" "}
                    </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                      <Button
                        className="btn-sm mx-2"
                        onClick={() => editclient(true)}
                        >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                <Col lg={6}>
                    <label>Financial Year</label>
                    <span>{client.financial_year_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Email</label>
                    <span>{client.email}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Phone</label>
                    <span>{client.phone}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Address</label>
                    <span>{client.address}</span>
                  </Col>
                  
                  <Col lg={6}>
                    <label>City</label>
                    <span>{client.city}</span>
                  </Col>
                 
                  <Col lg={6}>
                    <label>District</label>
                    <span>{client.district}</span>
                  </Col>
                  <Col lg={6}>
                    <label>State</label>
                    <span>{client.state}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Country</label>
                    <span>{client.country}</span>
                  </Col>
              
                  <Col lg={6}>
                    <label>Pincode</label> 
                    <span>{client.pincode}</span>
                  </Col>
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        Bank Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Pan Number</label> 
                    <span>{client.pan_number}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Gst No</label> 
                    <span>{client.gst_no}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Tin No</label> 
                    <span>{client.tin_no}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Ecc No</label> 
                    <span>{client.ecc_no}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Remark</label> 
                    <span>{client.remark}</span>
                  </Col>
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        User Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Created By</label> 
                    <span>{client.createdbyname}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Lastmodified By</label> 
                    <span>{client.lastmodifiedbyname}</span>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
             
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default ContactView;
